import { CHANNEL_SETTINGS_ACTIONS, CHANNEL_SETTINGS_ACTION_TYPES } from "../actions/channelSettings"
import produce, { enableES5} from "immer"

enableES5();

export type ChannelSettingsState = {
  [key: number]: ChannelSettings
}

export type ChannelSettings = {
  initialCentroid: "default" | "last",
  showFamilyColors: boolean,
  channelUpdates: "prompt" | "immediate",
  lastVisited: {
    centroidId?: number,
    familyTag?: string
  }
}

export const initialChannelSettings: ChannelSettings = {
  initialCentroid: "default",
  showFamilyColors: true,
  channelUpdates: "immediate",
  lastVisited: {}
}

export default (state: ChannelSettingsState = {}, action: CHANNEL_SETTINGS_ACTION_TYPES): ChannelSettingsState => {
  switch (action.type) {
    case CHANNEL_SETTINGS_ACTIONS.CHANGE_SETTING:
      return produce(state, (draft: ChannelSettingsState) => {
        // If the channel settings don't exist yet, initualize them with the defaults first.
        if (typeof draft[action.channelId] === "undefined") {
          draft[action.channelId] = {
            ...initialChannelSettings,
            [action.property]: action.value
          }
        } else {
          draft[action.channelId] = {
            ...draft[action.channelId],
            [action.property]: action.value
          }
        }
      });
     case CHANNEL_SETTINGS_ACTIONS.SAVE_LAST_VISITED:
      return produce(state, (draft: ChannelSettingsState) => {
        // If the channel settings don't exist yet, initualize them with the defaults first.
        if (typeof draft[action.channelId] === "undefined") {
          draft[action.channelId] = {
            ...initialChannelSettings,
            lastVisited: {
              centroidId: action.centroidId,
              familyTag: action.familyTag
            }
          }
        } else {
          draft[action.channelId].lastVisited = {
            centroidId: action.centroidId,
            familyTag: action.familyTag
          }
        }
      });
    default:
      return state
  }
}